<template>
  <b-navbar class="app-nav px-32 shadow-md">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img class="logo" src="https://res.cloudinary.com/xtellar/image/upload/v1578511503/PhanerooPrayer/phaneroo-logo_ecz5a9.png"
          alt="Phaneroo">
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        Home
      </b-navbar-item>
      <b-navbar-item tag="router-link" v-if="isAuthenticated" :to="{ path: '/dashboard' }">
        Dashboard
      </b-navbar-item>
      <b-navbar-item target="_blank" href="https://phaneroo.org/contact-us/">
        Contact
      </b-navbar-item>
    </template>

    <template slot="end">
      <b-navbar-item tag="div">
        <div class="buttons">
          <template v-if="!isAuthenticated">
            <b-button
              tag="router-link"
              :to="{ path: '/signup'}"
              type="is-primary"
            >
              Sign up
            </b-button>
            <b-button
              tag="router-link"
              :to="{ path: '/admin/login'}"
              type="is-light"
            >
              Log in
            </b-button>
          </template>
          <b-button
            v-else
            @click="logout"
            type="is-light"
            icon-left="sign-out"
          >
            Log out
          </b-button>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar',
  inject: ['$isAuthenticated'],
  computed: {
    isAuthenticated () {
      return this.$isAuthenticated()
    }
  },
  methods: {
    async logout () {
      try {
        await this.$store.dispatch('auth/logout')
        this.$router.push('/admin/login')
      } catch (error) {
        console.error('Error logging out', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  @apply w-24 max-h-full
}

@media (max-width: 768px) {
  .app-nav {
    @apply px-0;
  }
}
</style>
